/** Megabytes to a one-decimal GB string; non-finite input renders as an em dash. */
export function formatGb(mb: number): string {
  if (!Number.isFinite(mb)) return '—';
  return (mb / 1024).toFixed(1);
}

/** Milliseconds to a compact duration ("<1s", "42s", "3m 05s", "1h 02m"); invalid input renders as an em dash. */
export function formatDuration(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return '—';
  if (ms < 1000) return '<1s';
  if (ms < 60_000) return `${Math.floor(ms / 1000)}s`;
  if (ms < 3_600_000) {
    const m = Math.floor(ms / 60_000);
    const s = Math.floor((ms % 60_000) / 1000);
    return `${m}m ${String(s).padStart(2, '0')}s`;
  }
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  return `${h}h ${String(m).padStart(2, '0')}m`;
}

/** Turns an audit action id ("app.deploy", "api_key_create") into lowercase words; empty renders as an em dash. */
export function humanizeAction(action: string | null | undefined): string {
  const out = (action ?? '').replace(/[_.-]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  return out || '—';
}

/** Bytes to a human string ("512 B", "1.5 KB", "1.0 MB"); invalid input renders as an em dash. Caps at TB. */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes < 0) return '—';
  const rounded = Math.round(bytes);
  if (rounded < 1024) return `${rounded} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let i = 0;
  while (i < units.length - 1 && Number(value.toFixed(1)) >= 1024) {
    value /= 1024;
    i++;
  }
  return `${value.toFixed(1)} ${units[i]}`;
}
